import * as swcHelpers from '@swc/helpers';
import { placeholderImage, createImageUrl, isString } from '@grandvisionhq/utils';
import '../../../../types/product.js';
import { SINGLE_PURCHASE } from '../../../../types/purchase-types.js';
import { customTransitionLensConfig, defaultTransitionLensConfig } from '../config/transition-lens-config.js';

const defaultImageParams = {
    fit: 'fill',
    format: 'png'
};
const mapGraphVariantsToVirtualMirror = (product, variants, activeSku, brandLogo, isVtoTransitionsEnabled = false)=>{
    const prices = variants.filter((variant)=>variant.isVtoEnabled
    ).map((variant)=>{
        const { purchaseTypePrices , sku  } = variant;
        const { originalPrice , discountedPrice , currency  } = purchaseTypePrices[SINGLE_PURCHASE];
        return swcHelpers.objectSpread({
            upc: sku,
            current: {
                text: `${originalPrice}`,
                value: originalPrice
            }
        }, discountedPrice && {
            previous: {
                text: `${originalPrice}`,
                value: originalPrice
            },
            current: {
                text: discountedPrice && `${discountedPrice}`,
                value: discountedPrice && discountedPrice
            }
        }, {
            currency
        });
    }).reduce((acc, curr)=>{
        return (curr === null || curr === void 0 ? void 0 : curr.upc) === activeSku ? [
            curr,
            ...acc
        ] : [
            ...acc,
            curr
        ];
    }, []);
    const isTransitionEnabled = isVtoTransitionsEnabled && product.isOfferedWithPrescriptions;
    const products = variants.filter((variant)=>variant.isVtoEnabled
    ).map((variant)=>{
        var ref, ref1, ref2;
        const { brandModelCode , brandModelColorCode , sku , displayName , media , specifications  } = variant;
        const variantImages = ((ref = media.images) === null || ref === void 0 ? void 0 : ref.length) > 0 ? media.images : [
            placeholderImage
        ];
        const frameColors = (ref1 = specifications.find((spec)=>spec.specificationAttribute === 'frameColor'
        )) === null || ref1 === void 0 ? void 0 : ref1.value;
        const frameColor = Array.isArray(frameColors) ? frameColors.join(' / ') : frameColors;
        const lensColor = (ref2 = specifications.find((spec)=>spec.specificationAttribute === 'lensColor'
        )) === null || ref2 === void 0 ? void 0 : ref2.value;
        const transitionLens = isTransitionEnabled ? customTransitionLensConfig : defaultTransitionLensConfig;
        return {
            upc: sku,
            code: brandModelCode !== null && brandModelCode !== void 0 ? brandModelCode : '',
            name: displayName,
            colorCode: brandModelColorCode !== null && brandModelColorCode !== void 0 ? brandModelColorCode : '',
            thumbnailUrl: createImageUrl(variantImages[0].url, swcHelpers.objectSpread({}, defaultImageParams, {
                width: 224
            })),
            brand: {
                name: product.brandName,
                logoUrl: brandLogo !== null && brandLogo !== void 0 ? brandLogo : ''
            },
            lensColorLabel: isString(lensColor) ? lensColor : '',
            frameColorLabel: isString(frameColor) ? frameColor : '',
            styleName: '',
            isCustom: false,
            size: '58 14',
            isTransition: isTransitionEnabled,
            transitionLens
        };
    }).reduce((acc, curr)=>curr.upc === activeSku ? [
            curr,
            ...acc
        ] : [
            ...acc,
            curr
        ]
    , []);
    return {
        prices,
        products
    };
};

export { mapGraphVariantsToVirtualMirror };
//# sourceMappingURL=mapGraphVariantsToVirtualMirror.js.map
